import React from 'react';
import { FAQItem } from '../shared/FAQItem';
export const FAQSection = () => {
  const faqs = [{
    question: 'How is ApplyPass different from other coaching services?',
    answer: 'Our coaches are exclusively former hiring managers and senior engineers from top tech companies. We focus on personalized strategies rather than generic advice, and our track record shows consistently higher offer rates and compensation increases.'
  }, {
    question: 'How long does the coaching program last?',
    answer: 'Our coaching programs range from 6 weeks (Silver) to 16 weeks (Platinum), depending on your goals and timeline. We also offer flexible scheduling to accommodate your current work commitments.'
  }, {
    question: 'Do you guarantee job placement?',
    answer: "While we can't guarantee specific job placements, our clients have a 94% success rate in receiving offers from their target companies. Our focus is on giving you the skills, preparation, and confidence to excel in the interview process."
  }, {
    question: 'Is the investment worth it?',
    answer: 'Our clients see an average return of 5-10x on their investment through increased compensation. Beyond the immediate financial return, the skills and strategies you learn will benefit your career for years to come.'
  }];
  return <section className="w-full bg-gradient-to-br from-[#1a0d24] to-[#231232] py-24" data-id="element-159">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-160">
        <div className="text-center mb-16" data-id="element-161">
          <h2 className="text-4xl font-outfit font-bold mb-6 text-white" data-id="element-162">
            Frequently Asked Questions
          </h2>
        </div>
        <div className="bg-[#231232]/70 backdrop-blur-sm border border-[#6805DA]/20 rounded-xl overflow-hidden px-6" data-id="element-163">
          {faqs.map((faq, index) => <FAQItem key={index} question={faq.question} answer={faq.answer} data-id="element-164" />)}
        </div>
      </div>
    </section>;
};